import { forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Text, TextProps } from '@backstage/ui';

const styles = createStyles({
  root: {},
});

export interface ExpressionOperatorProps
  extends TextProps,
    WithStyles<typeof styles> {}

const ExpressionOperator = forwardRef<HTMLDivElement, ExpressionOperatorProps>(
  (props, ref) => {
    const { classes, className, ...rest } = props;
    return (
      <Text
        ref={ref}
        color="secondary"
        className={classNames(className, classes.root)}
        {...rest}
      />
    );
  },
);

ExpressionOperator.displayName = 'Expression.Operator';

export default withStyles(styles)(ExpressionOperator);
